import { tns } from 'tiny-slider/src/tiny-slider'

let pageSlider = null
let lightboxSlider = null
let lightboxOverlay = null
let allImages = []

function createLightboxOverlay() {
  if (lightboxOverlay) return

  lightboxOverlay = document.createElement('div')
  lightboxOverlay.id = 'gallery-lightbox'
  lightboxOverlay.className = 'fixed inset-0 z-[100] bg-black/95 flex flex-col hidden'

  lightboxOverlay.innerHTML = `
    <div class="flex items-center justify-between px-4 py-3 shrink-0">
      <span id="lightbox-counter" class="text-white/80 text-sm font-semibold tracking-[0.05em] tabular-nums"></span>
      <button id="lightbox-close" class="text-white/80 hover:text-white p-2 rounded-full hover:bg-white/10 transition" aria-label="Close">
        <span class="material-symbols-outlined text-2xl">close</span>
      </button>
    </div>
    <div class="flex-1 flex items-center justify-center min-h-0">
      <div id="lightbox-slider" class="w-full h-full">
        ${allImages.map(url => `<div class="h-full flex items-center justify-center"><img src="${url}" alt="" class="max-w-full max-h-[calc(100vh-160px)] w-auto h-auto object-contain"></div>`).join('')}
      </div>
    </div>
    <div id="lightbox-thumbs" class="shrink-0 px-4 py-3 flex gap-2 overflow-x-auto justify-center">
      ${allImages.map((url, i) => `<button data-index="${i}" class="shrink-0 w-14 h-9 rounded overflow-hidden border-2 border-transparent opacity-60 hover:opacity-100 transition focus:outline-none"><img src="${url}" alt="" class="w-full h-full object-cover"></button>`).join('')}
    </div>
  `

  document.body.appendChild(lightboxOverlay)

  lightboxOverlay.querySelector('#lightbox-close').addEventListener('click', closeLightbox)

  lightboxOverlay.querySelector('#lightbox-thumbs').addEventListener('click', (e) => {
    const btn = e.target.closest('button')
    if (btn && lightboxSlider) {
      lightboxSlider.goTo(parseInt(btn.dataset.index, 10))
    }
  })

  document.addEventListener('keydown', handleLightboxKeydown)
}

function handleLightboxKeydown(e) {
  if (!lightboxOverlay || lightboxOverlay.classList.contains('hidden')) return
  if (e.key === 'Escape') {
    closeLightbox()
  } else if (e.key === 'ArrowLeft' && lightboxSlider) {
    e.preventDefault()
    lightboxSlider.goTo('prev')
  } else if (e.key === 'ArrowRight' && lightboxSlider) {
    e.preventDefault()
    lightboxSlider.goTo('next')
  }
}

function initLightboxSlider(startIndex) {
  lightboxSlider = tns({
    container: '#lightbox-slider',
    mode: 'gallery',
    items: 1,
    speed: 300,
    startIndex: startIndex,
    nav: false,
    controls: true,
    controlsText: [
      '<span class="material-symbols-outlined text-3xl">chevron_left</span>',
      '<span class="material-symbols-outlined text-3xl">chevron_right</span>',
    ],
    loop: true,
    touch: true,
    mouseDrag: true,
    arrowKeys: false,
    preventScrollOnTouch: 'auto',
  })

  updateLightboxUI(startIndex)

  lightboxSlider.events.on('indexChanged', (info) => {
    updateLightboxUI(info.index)
  })
}

function updateLightboxUI(index) {
  const buttons = lightboxOverlay.querySelectorAll('#lightbox-thumbs button')
  buttons.forEach((btn, i) => {
    if (i === index) {
      btn.classList.add('!opacity-100', '!border-white')
      btn.classList.remove('opacity-60', 'border-transparent')
    } else {
      btn.classList.remove('!opacity-100', '!border-white')
      btn.classList.add('opacity-60', 'border-transparent')
    }
  })

  const counter = lightboxOverlay.querySelector('#lightbox-counter')
  if (counter) {
    counter.textContent = `${index + 1} / ${allImages.length}`
  }
}

export function openLightbox(startIndex) {
  if (!lightboxOverlay) createLightboxOverlay()

  lightboxOverlay.classList.remove('hidden')
  document.body.style.overflow = 'hidden'

  if (lightboxSlider) {
    lightboxSlider.goTo(startIndex)
    updateLightboxUI(startIndex)
  } else {
    initLightboxSlider(startIndex)
  }
}

export function closeLightbox() {
  if (lightboxOverlay) {
    lightboxOverlay.classList.add('hidden')
  }
  document.body.style.overflow = ''

  if (lightboxSlider) {
    lightboxSlider.destroy()
    lightboxSlider = null
  }
}

function updatePageUI(info) {
  const index = info.index
  const counter = document.getElementById('gallery-counter')
  if (counter) {
    counter.textContent = `${info.displayIndex} / ${info.slideCount}`
  }

  const buttons = document.querySelectorAll('.gallery-thumb-btn')
  buttons.forEach((btn, i) => {
    if (i === index) {
      btn.classList.add('ring-2', 'ring-ui-primary', 'ring-offset-1')
      btn.classList.remove('opacity-70')
    } else {
      btn.classList.remove('ring-2', 'ring-ui-primary', 'ring-offset-1')
      btn.classList.add('opacity-70')
    }
  })
}

export function initGalleryCarousel(containerSelector) {
  const container = document.querySelector(containerSelector)
  if (!container) return

  const slides = container.querySelectorAll('.gallery-slide')
  allImages = Array.from(slides).map(slide => slide.querySelector('img').src)

  if (allImages.length === 0) return

  if (allImages.length === 1) {
    const thumbsRow = document.querySelector('.gallery-thumbs-row')
    const counter = document.getElementById('gallery-counter')
    const controls = container.querySelector('.gallery-controls')
    if (thumbsRow) thumbsRow.remove()
    if (counter) counter.remove()
    if (controls) controls.remove()

    const img = container.querySelector('.gallery-slide img')
    if (img) {
      img.addEventListener('click', () => openLightbox(0))
    }
    return
  }

  pageSlider = tns({
    container: containerSelector + ' .gallery-slider',
    items: 1,
    slideBy: 1,
    speed: 400,
    nav: false,
    controls: true,
    controlsContainer: container.querySelector('.gallery-controls'),
    controlsText: [
      '<span class="material-symbols-outlined">chevron_left</span>',
      '<span class="material-symbols-outlined">chevron_right</span>',
    ],
    loop: true,
    touch: true,
    mouseDrag: true,
    preventScrollOnTouch: 'auto',
  })

  updatePageUI(pageSlider.getInfo())

  pageSlider.events.on('indexChanged', (info) => {
    updatePageUI(info)
  })

  container.querySelectorAll('.gallery-thumb-btn').forEach((btn, i) => {
    btn.addEventListener('click', () => {
      pageSlider.goTo(i)
    })
  })

  container.addEventListener('click', (e) => {
    const img = e.target.closest('.gallery-slide img')
    if (img) {
      openLightbox(pageSlider.getInfo().index)
    }
  })
}
